// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-resource-metadata-postal_address_id.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($id: uuid!, $postal_address_id: uuid!) {
  update_tasks_resources_by_pk(
    pk_columns: { id: $id }
    _append: { metadata: { postal_address_id: $postal_address_id } }
  ) {
    id
    metadata
  }
}

`